import * as actionTypes from "../reducers/actionTypes";
import { LeagueService } from "@/services/leagueService";
import { AppDispatch } from "../store";

export const setLeagueResult = (league: any) => ({
    type: actionTypes.SET_LEAGUES_RESULT,
    payload: league
});

export const setHotLeagues = (leagues: any[]) => ({
    type: actionTypes.SET_HOT_LEAGUES,
    payload: leagues
});

export const setAllLeagues = (leagues: any[]) => ({
    type: actionTypes.SET_ALL_LEAGUES,
    payload: leagues
});

export const setHotLeaguesLoading = (loading: boolean) => ({
    type: actionTypes.SET_HOT_LEAGUES_LOADING,
    payload: loading
});

export const setAllLeaguesLoading = (loading: boolean) => ({
    type: actionTypes.SET_ALL_LEAGUES_LOADING,
    payload: loading
});

export const setHotLeaguesError = (error: string | null) => ({
    type: actionTypes.SET_HOT_LEAGUES_ERROR,
    payload: error
});

export const setAllLeaguesError = (error: string | null) => ({
    type: actionTypes.SET_ALL_LEAGUES_ERROR,
    payload: error
});

export const fetchHotLeagues = (params?: { page?: number; limit?: number; fields?: string }) => {
    return async (dispatch: AppDispatch) => {
        dispatch(setHotLeaguesLoading(true));
        dispatch(setHotLeaguesError(null));

        try {
            const leagues = await LeagueService.getHotLeagues(params || {});
            dispatch(setHotLeagues(leagues));
        } catch (error: any) {
            dispatch(setHotLeaguesError(error?.message || 'Failed to fetch hot leagues'));
        } finally {
            dispatch(setHotLeaguesLoading(false));
        }
    };
};

export const fetchAllLeagues = (params?: { fields?: string }) => {
    return async (dispatch: AppDispatch) => {
        dispatch(setAllLeaguesLoading(true));
        dispatch(setAllLeaguesError(null));

        try {
            const leagues = await LeagueService.getAllLeagues(params || {});
            dispatch(setAllLeagues(leagues));
        } catch (error: any) {
            dispatch(setAllLeaguesError(error?.message || 'Failed to fetch all leagues'));
        } finally {
            dispatch(setAllLeaguesLoading(false));
        }
    };
};